<!--  -->
<template>
  <div class=''>
    <PageTop />
    <UserBody />
  </div>
</template>

<script>
import UserBody from './components/body.vue'
import PageTop from '@/components/pageTop.vue'
export default {
  components: {
    PageTop,
    UserBody
  },
  data() {
    return {
    
    }
  },
  computed: {},
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
  
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  
  },
  methods: {
  
  },
}
</script>
<style lang='scss' scoped>

</style>